
import * as moment from 'moment';
export interface IPatient {
    id: number;
    first_name: string;
    last_name: string;
    full_name: string;
    birthdate: string;
    gender: string;
    email: string | null;
    phone_number: string;
    phone_number_2: string | null;
    city: string;
    state: string;
    zip_code: string;
    address: string;
    country: string;
    created: moment.Moment;
    language:string;
    modified: string;
    has_appointment: boolean;
    next_appointment: string;
    last_status: string;
    last_visit_date: moment.Moment;
    no_show: boolean;
    member_plan_id: string;
    mco_name: string;
    gic: number;
    ra: number;
    recert_date:  moment.Moment;
  }

  export class Patient {
    id: number;
    firstName: string;
    lastName: string;
    fullName: string;
    birthdate: string;
    gender: string;
    email: string | null;
    phoneNumber: string;
    phoneNumber2: string | null;
    city: string;
    state: string;
    zipCode: string;
    address: string;
    country: string;
    created:moment.Moment;
    modified: string;
    hasAppointment: boolean;
    nextAppointment: string;
    lastStatus: string;
    lastVisitDate:moment.Moment;
    noShow: boolean;
    language:string;
    memberPlanId: string;
    mcoName: string;
    gic: number;
    ra: number;
    recertDate: moment.Moment;

    constructor(data: IPatient) {
      this.id = data.id;
      this.firstName = data.first_name;
      this.lastName = data.last_name;
      this.fullName = data.full_name;
      this.birthdate = data.birthdate;
      this.gender = data.gender;
      this.email = data.email;
      this.phoneNumber = data.phone_number;
      this.phoneNumber2 = data.phone_number_2;
      this.city = data.city;
      this.address =data.address;
      this.state = data.state;
      this.zipCode = data.zip_code;
      this.country = data.country;
      this.created = data.created;
      this.modified = data.modified;
      this.hasAppointment = data.has_appointment;
      this.nextAppointment = data.next_appointment;
      this.lastStatus = data.last_status;
      this.lastVisitDate = data.last_visit_date;
      this.noShow = data.no_show;
      this.memberPlanId = data.member_plan_id;
      this.mcoName = data.mco_name;
      this.gic = data.gic;
      this.ra = data.ra;
      this.language=data.language;
      this.recertDate = data.recert_date;
    }
  }
